import { createContext, type ReactNode, useContext } from 'react';
import moment, { type Moment } from 'moment';
import { type StateSetter } from 'types/utils/React';
import { emptyFunction } from 'utils/functions';
import { type EventsAndTimeslots } from 'types/Event';

export type CalendarContextProps = {
  currentDate: Moment;
  currentMonthEventsAndTimeslots: EventsAndTimeslots;
  disabled: boolean;
  selectedDate?: Moment;
  selectedDayEventsAndTimeslots: EventsAndTimeslots;
  setCurrentDate: StateSetter<Moment>;
  handleSelectedDateChange: (newSelectedDate: Moment | undefined) => void;
};

const initialState = {
  currentDate: moment(),
  currentMonthEventsAndTimeslots: [],
  disabled: false,
  selectedDate: undefined,
  selectedDayEventsAndTimeslots: [],
  setCurrentDate: emptyFunction,
  handleSelectedDateChange: emptyFunction,
};

export const CalendarContext = createContext<CalendarContextProps>(initialState);

const { Provider } = CalendarContext;

export type CalendarProviderProps = {
  children: ReactNode;
  currentDate: Moment;
  currentMonthEventsAndTimeslots: EventsAndTimeslots;
  disabled: boolean;
  selectedDate?: Moment;
  selectedDayEventsAndTimeslots: EventsAndTimeslots;
  setCurrentDate: StateSetter<Moment>;
  handleSelectedDateChange: (newSelectedDate: Moment | undefined) => void;
};

export const CalendarProvider = ({
  children,
  ...props
}: CalendarProviderProps): JSX.Element => (
  <Provider
    value={{
      ...props,
    }}
  >
    {children}
  </Provider>
);

export const useCalendarContext = () => useContext(CalendarContext);

export default useCalendarContext;